let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1u76X")).then(() => parcelRequire('1M5gW'));